import { render } from "./FoodOrders-detail-group.vue?vue&type=template&id=6eb0f4e8"
import script from "./FoodOrders-detail-group.vue?vue&type=script&lang=js"
export * from "./FoodOrders-detail-group.vue?vue&type=script&lang=js"

import "./FoodOrders-detail-group.vue?vue&type=style&index=0&id=6eb0f4e8&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__